import { TIER_LABELS } from '../../utils/badges';
import BADGE_ART from '../../assets/badges';

/** One badge: David's artwork, knocked back to a dark silhouette with a lock until it's earned. */
export default function BadgeArt({ badge, locked = false, size = 48, isNew = false }) {
  const src = BADGE_ART[badge.id];
  // --badge-mask keeps the unlock shine inside the badge's own shape
  return (
    <span
      className={`badge-art${locked ? ' is-locked' : ''}${isNew ? ' is-new' : ''}`}
      style={{ '--badge-size': `${size}px`, '--badge-mask': `url(${src}) center / contain no-repeat` }}
    >
      <img src={src} alt="" width={size} height={size} draggable="false" />
      {locked && (
        <span className="badge-art__lock" aria-hidden="true">
          <span className="material-symbols-rounded">lock</span>
        </span>
      )}
      <span className="sr-only">
        {`${badge.familyName}, ${TIER_LABELS[badge.tier]}${locked ? ', locked' : ''}`}
      </span>
    </span>
  );
}
